module.exports = __webpack_public_path__ + "a768e7de/img/google.68f3823e.svg";